export const isGameActivity = (activityType: string | undefined) =>
  !!activityType?.startsWith('game_');
